import React from "react";

import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from '@mui/material/Typography';

const applicationBarSx = {
  rootSx: {
    pt: 3
  },
  titleSx: {
    fontWeight: 300,
    fontSize: 28,
    pb: 1
  },
}

const getTabIndex = () => {
  let index = NaN;
  switch(window.location.pathname) {
    case '/':
    case '/uk':
      index = 0;
      break;
    case '/eng':
      index = 1;
      break;
    case '/about':
      index = 2;
      break;
    default:
      break;
  }
  return index;
}

const ApplicationBar = () => {
  const {rootSx, titleSx} = applicationBarSx;
  return (
    <AppBar position="fixed" sx={rootSx}>
      <Typography component="h1" align="center" sx={titleSx}>
        COVID-19 models using web search data
      </Typography>
      <Tabs value={getTabIndex()}>
        <Tab label="UK" href="/uk" component={Button} />
        <Tab label="England" href="/eng" component={Button} />
        <Tab label="About" href="/about" component={Button} />
      </Tabs>
    </AppBar>
  );
};

export default ApplicationBar;
